import { render, staticRenderFns } from "./OrganizationAdd.vue?vue&type=template&id=4e3c0d79&scoped=true&"
import script from "./OrganizationAdd.vue?vue&type=script&lang=js&"
export * from "./OrganizationAdd.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationAdd.vue?vue&type=style&index=0&id=4e3c0d79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c0d79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VRow,VTextField})
